import type { InputState } from "../protocol/index.js";
import { MSG_INPUT, decAngle, encAngle } from "./codes.js";

// --- input (4 bytes) -------------------------------------------------------

export function encodeInput(i: InputState): Uint8Array {
  const buf = new ArrayBuffer(4);
  const dv = new DataView(buf);
  dv.setUint8(0, MSG_INPUT);
  let bits = 0;
  if (i.forward) bits |= 1;
  if (i.backward) bits |= 2;
  if (i.turnLeft) bits |= 4;
  if (i.turnRight) bits |= 8;
  if (i.fire) bits |= 16;
  if (i.eightDir) bits |= 32;
  if (i.joystick) bits |= 64;
  dv.setUint8(1, bits);
  dv.setInt16(2, encAngle(i.aim), true);
  return new Uint8Array(buf);
}

export function decodeInput(buf: ArrayBuffer): InputState {
  const dv = new DataView(buf);
  const bits = dv.getUint8(1);
  return {
    forward: (bits & 1) !== 0,
    backward: (bits & 2) !== 0,
    turnLeft: (bits & 4) !== 0,
    turnRight: (bits & 8) !== 0,
    fire: (bits & 16) !== 0,
    eightDir: (bits & 32) !== 0,
    joystick: (bits & 64) !== 0,
    aim: decAngle(dv.getInt16(2, true)),
  };
}
